import { useEffect, useRef } from "react";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { Box, styled } from "@mui/material";

const VideoContainer = styled(Box)<{ size?: "small" | "medium" | "large" }>(({ size }) => ({
    width: '100%',
    objectFit: 'cover',
    borderRadius: '12px',
    "& .video-js .vjs-big-play-button": {
        bottom: size === "small" ? '5px' : '10px',
        right: size === "small" ? '5px' : '10px',
        left: 'auto',
        top: 'auto',
        width: size === "small" ? '60px' : size === "medium" ? '80px' : '80px',
        height: size === "small" ? '40px' : size === "medium" ? '60px' : '60px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        border: '2px solid white',
        transform: 'none',
        margin: '0',
    },
    "& .video-js .vjs-big-play-button .vjs-icon-placeholder": {
        lineHeight: size === "small" ? '38px' : size === "medium" ? '50px' : '60px',
        fontSize: size === "small" ? '24px' : size === "medium" ? '28px' : '32px',
    }
}));

export const VideoJS = ({ src, onReady, onPlay, startAt = 0, size = "small" }: { src: string; onReady?: (player: any) => void, onPlay?: () => void, startAt?: number, size?: "small" | "medium" | "large" }) => {
    const videoRef = useRef<HTMLDivElement>(null);
    const playerRef = useRef<any>(null);

    useEffect(() => {
        if (!videoRef.current) return;

        const videoElement = document.createElement('video');
        videoElement.className = 'video-js vjs-default-skin';
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'cover';
        videoElement.style.borderRadius = '12px';
        
        videoRef.current.appendChild(videoElement);

        const player = videojs(videoElement, {
            controls: true,
            fluid: true,
            responsive: true,
            sources: [{
                src: src,
                type: 'video/mp4' // Adjust type based on your video format
            }]
        });

        playerRef.current = player;

        // Set the initial time to 1 second when the video is ready
        player.ready(() => {
            if (startAt) {
                player.currentTime(startAt);
            }

            if (onPlay) {
                player.on('play', onPlay);
            }
            
            if (onReady) {
                onReady(player);
            }
        });

        return () => {
            if (playerRef.current) {
                playerRef.current.dispose();
                playerRef.current = null;
            }
        };
    }, [src, onReady]);

    return <VideoContainer ref={videoRef} size={size} />;
};